export const WHATSAPP_DISPLAY = "+91 96199 56604";
export const WHATSAPP_NUMBER = "919619956604";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const WA_DEFAULT = waLink(
  "Hello Shivaay Consultant! I'm looking for a property between Borivali and Andheri (East/West). Please share your current inventory."
);

export const NAV_LINKS = [
  { label: "Listings", href: "#inventory" },
  { label: "Matcher", href: "#matcher" },
  { label: "Social", href: "#social" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1682414593649-c3e4024a7995?crop=entropy&cs=srgb&fm=jpg&q=85",
  coast: "https://images.unsplash.com/photo-1653299448072-fb7408c264b3?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const LOCALITIES = [
  "Andheri West",
  "Andheri East",
  "Borivali West",
  "Borivali East",
  "Kandivali West",
  "Kandivali East",
  "Malad West",
  "Malad East",
  "Goregaon West",
  "Goregaon East",
  "Jogeshwari East",
];

export const PLATFORM_META = {
  housing: { label: "Housing.com", color: "#E40046" },
  acres: { label: "99acres", color: "#4A90D9" },
};

export const SOCIALS = {
  instagram: "https://instagram.com/shivaayconsultant_",
  facebook: "https://facebook.com/shivaayconsultant_",
  youtube: "https://youtube.com/@shivaayconsultant",
};
